import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format any stored timestamp into Japan Standard Time (Asia/Tokyo).
 * - Full ISO strings (with Z / ±hh:mm) are converted from their zone to JST.
 * - Naive timestamps (no timezone) are treated as UTC (that is how the backend
 *   stores them) so they don't get mis-read as the viewer's local time.
 * Returns e.g. "2026-06-10 17:33 JST" (or "2026-06-10" when withTime=false).
 */
export function formatJst(value, { withTime = true } = {}) {
  if (!value) return "—";
  let s = String(value).trim();
  const hasTz = /([zZ])|([+-]\d{2}:?\d{2})$/.test(s);
  if (!hasTz) s = s.replace(" ", "T") + "Z"; // naive → interpret as UTC
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return String(value);
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Tokyo",
    year: "numeric", month: "2-digit", day: "2-digit",
    ...(withTime ? { hour: "2-digit", minute: "2-digit", hour12: false } : {}),
  }).formatToParts(d);
  const get = (t) => parts.find((p) => p.type === t)?.value || "";
  const date = `${get("year")}-${get("month")}-${get("day")}`;
  if (!withTime) return date;
  let hh = get("hour");
  if (hh === "24") hh = "00"; // Intl edge case at midnight
  return `${date} ${hh}:${get("minute")} JST`;
}
